const EmrysetAssos = () => {
    return (
        <div>
            <h1>Emrys et les Assos</h1>
        </div>
    );
};

export default EmrysetAssos;
